import { i18n } from "../translate/i18n";

const PAGES = [
  { path: "/", key: "dashboard" },
  { path: "/tickets", key: "tickets" },
  { path: "/contacts", key: "contacts" },
  { path: "/schedules", key: "schedules" },
  { path: "/chats", key: "chats" },
  { path: "/kanban", key: "kanbanTags" },
  { path: "/kanbanContact", key: "kanbanContacts" },
  { path: "/quick-messages", key: "quickMessages" },
  { path: "/template-message", key: "templateMessage" },
  { path: "/tags", key: "tags" },
  { path: "/connections", key: "connections" },
  { path: "/ad-campaigns", key: "adCampaigns" },
  { path: "/calls/history", key: "callHistory", prefix: "calls" },
  { path: "/calls/metrics", key: "callMetrics", prefix: "calls" },
  { path: "/auditor", key: "auditor" },
  { path: "/ai-replies", key: "aiReplies" },
  { path: "/activity", key: "activity" },
  { path: "/analytics", key: "analytics" },
  { path: "/campaigns", key: "campaignsList", prefix: "campaigns" },
  { path: "/contact-lists", key: "campaigns", label: "Listas de contactos" },
  { path: "/campaigns-config", key: "campaignsSettings", prefix: "campaigns" },
  { path: "/prompts", key: "prompts" },
  { path: "/data-sources", key: "dataSources" },
  { path: "/testing", key: "testing" },
  { path: "/ai-costs", key: "aiCosts" },
  { path: "/queue-integration", key: "queueIntegration" },
  { path: "/queues", key: "queues" },
  { path: "/messages-api", key: "api" },
  { path: "/users", key: "users" },
  { path: "/financeiro", key: "financeiro" },
  { path: "/announcements", key: "annoucements" },
  { path: "/settings", key: "settings" },
  { path: "/todolist", label: "Tareas" },
];

const labelOf = (page) => {
  const base = page.label || i18n.t(`mainDrawer.listItems.${page.key}`);
  if (!page.prefix) return base;
  return `${i18n.t(`mainDrawer.listItems.${page.prefix}`)} · ${base}`;
};

export const helpPages = () => PAGES.map((p) => ({ path: p.path, label: labelOf(p) }));

export const helpPageLabel = (path) => {
  const page = PAGES.find((p) => p.path === path);
  return page ? labelOf(page) : path;
};

export const matchHelpPage = (pathname) => {
  const actual = String(pathname || "/").replace(/\/+$/, "") || "/";
  if (actual === "/") return "/";

  return PAGES.map((p) => p.path)
    .filter((path) => path !== "/" && (actual === path || actual.startsWith(`${path}/`)))
    .sort((a, b) => b.length - a.length)[0] || null;
};

export const youtubeId = (video) => {
  const m = String(youtubeEmbedUrl(video)).match(/youtube\.com\/embed\/([\w-]{6,})/);
  return m ? m[1] : null;
};

export const youtubeEmbedUrl = (video) => {
  const valor = String(video || "").trim();
  if (!valor) return "";

  const patrones = [
    /youtube\.com\/watch\?[^#]*v=([\w-]{6,})/i,
    /youtu\.be\/([\w-]{6,})/i,
    /youtube\.com\/(?:embed|shorts|live)\/([\w-]{6,})/i,
  ];

  for (const patron of patrones) {
    const m = valor.match(patron);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
  }

  if (/^[\w-]{6,}$/.test(valor)) return `https://www.youtube.com/embed/${valor}`;

  return valor;
};
